module.exports = __webpack_public_path__ + "static/media/branch1.fa769446.png";